<button class="btn btn-outline-primary mb-1 mr-2" *ngFor="let ticket of pausedTickets"
    (click)="callPausedTicket(ticket.id)">
    <span [title]="jsonToNote(ticket)" class="font-weight-bold">{{ ticket.caption }}</span><br><span>{{ jsonToNoteShort(ticket) }}</span>
</button>